import { useState, type FormEvent } from "react";
import { HONEYPOT_FIELD_NAME, isHoneypotFilled, submitFormUrl } from "@/utils/formSubmit";

const SUBMIT_ADDR = "https://readdy.ai/api/form/dahfl2bp14a1h3mr6ks0";

export default function SubscribeForm() {
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [feedback, setFeedback] = useState("");

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formEl = event.currentTarget;

    if (isHoneypotFilled(formEl)) {
      setStatus("success");
      setFeedback("订阅成功，我们会把最新调查发到你的邮箱。");
      return;
    }

    setStatus("loading");
    setFeedback("");

    const result = await submitFormUrl(SUBMIT_ADDR, formEl);

    if (result.ok) {
      setStatus("success");
      setFeedback("订阅成功，我们会把最新调查发到你的邮箱。");
      formEl.reset();
    } else {
      setStatus("error");
      setFeedback(result.message || "订阅未成功，请稍后重试。");
    }
  };

  return (
    <form
      id="subscribe-form"
      data-readdy-form
      action={SUBMIT_ADDR}
      method="post"
      onSubmit={handleSubmit}
      className="w-full"
    >
      <label htmlFor="subscribe-email" className="block text-sm font-medium text-background-100 mb-2">
        订阅最新调查
      </label>
      <div className="flex flex-col sm:flex-row gap-2">
        <input
          id="subscribe-email"
          type="email"
          name="email"
          required
          autoComplete="email"
          placeholder="你的邮箱地址"
          className="form-field flex-1 min-w-0 px-4 py-2.5 rounded-md text-sm bg-background-50/10 border border-background-50/25 text-background-50 placeholder:text-background-300 focus:bg-background-50/15"
        />
        <input
          type="text"
          name={HONEYPOT_FIELD_NAME}
          className="field-verify-extra"
          tabIndex={-1}
          autoComplete="off"
          aria-hidden="true"
          readOnly
        />
        <button
          type="submit"
          disabled={status === "loading"}
          className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-md text-sm font-medium whitespace-nowrap cursor-pointer transition-colors bg-accent-500 text-foreground-950 hover:bg-accent-400 disabled:opacity-60 disabled:cursor-not-allowed"
        >
          <i className={status === "loading" ? "ri-loader-4-line animate-spin" : "ri-send-plane-line"} aria-hidden="true"></i>
          {status === "loading" ? "提交中" : "立即订阅"}
        </button>
      </div>
      {status !== "idle" && status !== "loading" && (
        <p
          role="status"
          className={`mt-2 text-xs leading-relaxed ${
            status === "success" ? "text-accent-300" : "text-primary-300"
          }`}
        >
          {feedback}
        </p>
      )}
      <p className="mt-2 text-xs text-background-400 leading-relaxed">
        我们只发送调查更新，不做营销推广，随时可以退订。
      </p>
    </form>
  );
}